module.exports = __webpack_public_path__ + "media/insights/building_icon-2650faf8.png";